import React from 'react';
import { ICompanyLookup } from './interfaces';
import { CompanyModel } from '../../../api-service/clients';

export function formatCompany(company?: CompanyModel) {
  if (!company || !company.name) {
    return '';
  }

  const { name, productionUnitIdentifier, streetName, streetNumber, floorIdentifier, postalCode, city, primaryTradeCodeName } = company;

  let postText = '';

  // [Virksomhedens navn] ([p-nummer], [adresse], [primær branche])

  if (productionUnitIdentifier) {
    postText += productionUnitIdentifier;
  }
  if (streetName && streetNumber) {
    postText += `${postText ? ', ' : ''}${streetName} ${streetNumber}`;
    if (floorIdentifier) {
      postText += `, ${floorIdentifier}`;
    }
  }

  if (postalCode && city) {
    postText += `${postText ? ', ' : ''}${postalCode} ${city}`;
  }

  if (primaryTradeCodeName) {
    postText += `, ${primaryTradeCodeName}`;
  }

  if (postText) {
    postText = ` (${postText})`;
  }
  return `${name}${postText}`;
}

export function formatCompanyAddress(company?: ICompanyLookup) {
  if (!company || !company.name) return '';

  const { streetName, streetNumber, floorIdentifier, postalCode, city } = company;
  let postText = '';

  if (streetName && streetNumber) {
    postText += `${postText ? ', ' : ''}${streetName} ${streetNumber}`;
    if (floorIdentifier) {
      postText += `, ${floorIdentifier}`;
    }
  }

  if (postalCode && city) {
    postText += `${postText ? ', ' : ''}${postalCode} ${city}`;
  }

  if (postText) {
    postText = `${postText}`;
  }
  return `${postText}`;
}
export function renderCompany(props: object, company?: ICompanyLookup) {
  return (
    <li {...props} key={company?.id}>
      {formatCompany(company)}
    </li>
  );
}
